import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import WorkIcon from "@material-ui/icons/Work";
import LocalLibraryIcon from "@material-ui/icons/School";
import SkillSvg from "../Assets/Images/about-shape.svg";
import { scrollReveal } from "../Assets/Hooks/Animation";
import { useScroll } from "../Assets/Hooks/useScroll";
import { motion } from "framer-motion";

const About = () => {
  const [tab, setTab] = useState("experience");
  const [element, controls] = useScroll();

  return (
    <motion.div id="about" className="about pb-6 pt-6">
      <img className="skills-img" src={SkillSvg} alt="" />

      <motion.div
        variants={window.innerWidth > 767 ? scrollReveal : null}
        ref={element}
        animate={controls}
        className="container"
      >
        <Row className="">
          <Col className="p-0 text-center" md={5}>
            <img
              placeholder="/images/skills/lod.jpeg"
              src="/images/mee.png"
              error="/images/skills/error.png"
              alt="React Cool Img"
              height="50%"
            />
          </Col>
          <Col className="" md={7}>
            <div className="about-info">
              <h1 className="pb-4">
                <span className="chonburi-font green-text ">Abo</span>ut Me
              </h1>
              <p className="details">
                Full-Stack Developer at Web4Next. I am seeking a challenging opportunity in an environment 
                where I will be able to utilize my strong organizational skills and ability to work well with people.
                Ready to work for an organization which provides me the opportunity to improve my skills and knowledge to growth 
                along with the organization objective.
              </p>
              <div className="d-flex align-items-center resume-section ">
                <h6>Resume :</h6>
                <a rel="noopener noreferrer" href="https://ninjasfiles.s3.amazonaws.com/Sachidanand%20Shah2.pdf_8e585703b650091d0a3c3526b5f8ddb1/Sachidanand%20Shah2.pdf" target="_blank">
                  View
                </a>
              </div>
              <div className="mt-5">
                <Row className="tabs mb-2">
                  <Col
                    className={`
                      ${tab === "experience"
                        ? "active-tab custom-mr-3"
                        : "inactive-tab"
                      } tab`}
                    onClick={() => setTab("experience")}
                  >
                    <WorkIcon />
                    <h5>Work Experiences</h5>
                  </Col>
                  <Col
                    className={`
                      ${tab === "education"
                        ? "active-tab custom-ml-3"
                        : "inactive-tab"
                      } tab`}
                    onClick={() => setTab("education")}
                  >
                    <LocalLibraryIcon />
                    <h5>Educations</h5>
                  </Col>
                </Row>
                <br/>
                <div className="about-sub-data">
                  {tab === "experience" ? (
                    <div className="work-experiences">
                      <h5>Web4Next</h5>
                      <ul>
                        <li>
                          Working As a Trainee Full-Stack Developer (Tech - NodeJS, ReactJS)
                        </li> 
                      </ul>
                    </div>
                  ) : null}
                  {tab === "education" ? (
                    <div className="education">
                      <div>
                        <h5>B.Tech</h5>
                        <ul>
                          <li className="text-justify">
                            Graduated in Electrical and Electronics Engineering from
                            Rajiv Gandhi Proudyogiki Vishwavidyalaya in
                            2020.
                          </li>
                        </ul>
                      </div>
                      <div>
                        <h5>Full Stack Development</h5>
                        <ul>
                          <li className="text-justify">
                            I Completed Full Stack Development Training Course from Coding Ninjas in 2022.
                          </li>
                        </ul>
                      </div>
                    </div>
                    
                  ) : null}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </motion.div>
    </motion.div>
  );
};

export default About;
